import * as ValidateModel from '../shared/ValidateModel';
import Graphics from '../objects/graphicsLibrary/graphics';
import Graphic from '../objects/graphicsLibrary/graphic';

const fields = {
    ID: 'id',
    NAME: 'name',
    DESCRIPTION: 'description',
    MIME: 'mime',
    SOURCE: 'source',
    WIDTH: 'width',
    HEIGHT: 'height',
    FIXED_WIDTH: 'fixedWidth',
    FIXED_HEIGHT: 'fixedHeight',
    PRICE: 'price',
    PRICE_REPEAT_APPLY: 'priceRepeatApply',
    SIZE: 'size',
    CUSTOMERS: 'customers',
    DATE_UPD: 'dateUpd',
};

class GraphicsLibraryGraphicsConverter {
    static convertOne = (data: any): Graphic => {
        ValidateModel.isObject(data, 'data');
        const {
            [fields.ID]: id,
            [fields.NAME]: name,
            [fields.DESCRIPTION]: description,
            [fields.MIME]: mime,
            [fields.SOURCE]: source,
            [fields.WIDTH]: width,
            [fields.HEIGHT]: height,
            [fields.FIXED_WIDTH]: fixedWidth,
            [fields.FIXED_HEIGHT]: fixedHeight,
            [fields.PRICE]: price,
            [fields.PRICE_REPEAT_APPLY]: priceRepeatApply,
            [fields.SIZE]: size,
            [fields.CUSTOMERS]: customers,
            [fields.DATE_UPD]: dateUpd,
        } = data;
        return new Graphic(
            id,
            name,
            description,
            mime,
            source,
            width,
            height,
            fixedWidth,
            fixedHeight,
            price,
            priceRepeatApply,
            size,
            customers,
            dateUpd
        );
    };

    static convertAllToArray = (data: any[]): Graphic[] => {
        ValidateModel.isArray(data, 'data');
        return data.map((item) =>
            GraphicsLibraryGraphicsConverter.convertOne(item)
        );
    };

    static convertAll = (data: any[]): Graphics => {
        ValidateModel.isArray(data, 'data');
        return new Graphics(
            GraphicsLibraryGraphicsConverter.convertAllToArray(data)
        );
    };
}

export default GraphicsLibraryGraphicsConverter;
